import React, { useMemo } from 'react';

import { CardListFilterMenuButton } from '@vlabs/monokit/entities/cards/filters/CardListFilterMenuButton';
import { CreateCardButtonPoint3 } from '@vlabs/monokit/features/create-card';
import { PageHeader, usePageContext } from '@vlabs/monokit/shared/ui/page';
import { useHasPermission } from '@vlabs/permissions';
import { routes } from '@vlapps/point/src/app/routes';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router-dom';

import st from './CardListPageHeader.module.sass';
import { QuickSearchInput } from './quick-search-input';

interface CardListPageHeaderProps {
  title?: string;
  titleItems?: React.ReactNode | React.ReactNode[];
}

function CardListPageHeader({
  title = undefined,
  titleItems = undefined,
}: CardListPageHeaderProps): React.JSX.Element {
  const { t } = useTranslation();
  const pageCtx = usePageContext();
  const history = useHistory();
  const canCreateCard = useHasPermission('card', 'create');
  const $title = useMemo(() => (
    <div className={st.Title}>
      {pageCtx.getTitleComponent(title ?? t('card-list-page:title'))}
      {titleItems}
      <QuickSearchInput
        data-testid="CardListPage.QuickSearch"
        disabled
        size={pageCtx.inputSize}
      />
    </div>
  ), [t, title, titleItems, pageCtx]);

  return (
    <PageHeader
      actions={(
        <React.Fragment>
          {!!canCreateCard && (
            <CreateCardButtonPoint3
              onCreateCard={(cardId) => history.push(generatePath(routes.externalId.read, { externalId: cardId }))}
              size={pageCtx.buttonSize}
            />
          )}
          <CardListFilterMenuButton />
        </React.Fragment>
      )}
      title={$title}
    />
  );
}

export { CardListPageHeader };
